"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fgpPop = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var FgpPopAction_1 = require("@/pages/common/actions/FgpPopAction");
var FgpPopState_1 = require("@/pages/common/states/FgpPopState");
var mapStateToProps = function (state) { return (__assign({}, state.fgppop)); };
var mapDispatchToProps = function (dispatch) { return ({
    close: function () { return dispatch(FgpPopAction_1.default.close()); },
    onReadMoreClick: function () { return dispatch(FgpPopAction_1.default.onReadMoreClick()); },
}); };
exports.fgpPop = function (props) {
    if (!props.isActive)
        return null;
    var renderWithPhoto = function (props) {
        var altText = "OKAY.COM | Founding Member of Forbes Global Properties";
        return (React.createElement("div", { className: "c-fgppop__box" },
            React.createElement("div", { className: "c-fgppop__logo" },
                React.createElement("img", { alt: altText, src: "/res/img/okay-logo-fgp-column.png" })),
            React.createElement("div", { className: "c-fgppop__img" },
                React.createElement("img", { src: props.image, alt: "Popup background image" })),
            React.createElement("div", { className: "c-fgppop__text" },
                React.createElement("div", { className: "c-fgppop__title" }, props.t.title),
                React.createElement("div", { className: "c-fgppop__br" }),
                React.createElement("div", { className: "c-fgppop__caption" }, props.t.caption),
                React.createElement("div", { className: "c-fgppop__action" },
                    React.createElement("a", { onClick: function (e) { e.preventDefault(); props.onReadMoreClick(); }, href: "#", className: "c-fgppop__btn" }, props.t.readMore))),
            React.createElement("a", { onClick: function (e) { e.preventDefault(); props.close(); }, className: "c-fgppop__close", href: "#" },
                React.createElement("span", { className: "fal fa-times" }))));
    };
    var renderWithoutPhoto = function (props) {
        return (React.createElement("div", { className: "c-fgppop__box" },
            React.createElement("div", { className: "c-fgppop__container" },
                React.createElement("div", { className: "c-fgppop__ptitle", dangerouslySetInnerHTML: { __html: props.t.ptitleHtml } }),
                React.createElement("div", { className: "c-fgppop__pbr" }),
                React.createElement("div", { className: "c-fgppop__paction" },
                    React.createElement("a", { onClick: function (e) { e.preventDefault(); props.onReadMoreClick(); }, className: "c-fgppop__btn", href: "#" }, props.t.readMore))),
            React.createElement("a", { onClick: function (e) { e.preventDefault(); props.close(); }, className: "c-fgppop__close", href: "#" },
                React.createElement("span", { className: "fal fa-times" }))));
    };
    var onBgClick = function (e) {
        if (e.currentTarget !== e.target)
            return;
        props.close();
    };
    return (React.createElement("div", { onClick: onBgClick, className: "c-fgppop" },
        props.size === FgpPopState_1.FgpPopType.WITH_PHOTO ? renderWithPhoto(props) : null,
        props.size === FgpPopState_1.FgpPopType.WITHOUT_PHOTO ? renderWithoutPhoto(props) : null));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.fgpPop);
